import React from "react";
import { Currency } from "swan-public-api-client";
import { FormattedNumber } from "react-intl";

interface Props {
  value: number | null | undefined;
  currency: Currency | null | undefined;
}

export class FormattedCurrency extends React.PureComponent<Props> {
  public render() {
    if (this.props.value === undefined
      || this.props.value === null) {
      return ("–");
    }

    return (<FormattedNumber value={this.props.value} />);
  }
}
